(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar-1"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
      jQuery(document).ready(function($){
        var announceClose = $.cookie( 'announceCookie' );
    
        if( announceClose == 'true') {
          $(".announcement-bar").css({
            padding: "0",
            height: "0",
            opacity: "0",
            "z-index": "-1"
          });
        }
    
        $('.announcement-close').on("click", function(){
          $(".announcement-bar").css({
            padding: "0",
            height: "0",
            opacity: "0",
            "z-index": "-1"
          }), $.cookie("announceCookie", "true", {
              expires: 1,
              path: "/"
          });
        });
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-1"]) return;
  try {
    
  jQuery(document).ready(function($){
    $('.header__inline-menu li .mega-menu').hover(
        function() {
            $(this).attr('open', 'true');
            $(this).addClass('open');
        },
        function() {
            $(this).removeAttr('open');
            $(this).removeClass('open');
        }
    );
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-2"]) return;
  try {
    
  jQuery(document).ready(function($){
    $('.header__inline-menu li .mega-menu').hover(
        function() {
            $(this).attr('open', 'true');
            $(this).addClass('open');
        },
        function() {
            $(this).removeAttr('open');
            $(this).removeClass('open');
        }
    );
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-gallery"] && !Shopify.designMode) return;
  try {
    
  (function(){
    const images = document.querySelectorAll('.mw-image-gallery a');
    const modal = document.querySelector('.mw-modal');
    const modalImage = modal.querySelector('img');
    let currentIndex = 0;

    // Open modal popup and show clicked image
    function showModal(index) {
      if(window.innerWidth > 749){
        modalImage.src = images[index].dataset.desktop;
      } else {
        modalImage.src = images[index].dataset.mobile;
      }
      modal.classList.add('show');
      currentIndex = index;
    }

    // Hide modal popup
    function hideModal() {
      modal.classList.remove('show');
    }

    // Show previous image in gallery
    function showPrevImage(e) {
      e.stopPropagation()
      if (currentIndex === 0) {
        showModal(images.length - 1);
      } else {
        showModal(currentIndex - 1);
      }
    }

    // Show next image in gallery
    function showNextImage(e) {
      e.stopPropagation()
      if (currentIndex === images.length - 1) {
        showModal(0);
      } else {
        showModal(currentIndex + 1);
      }
    }

    // Add click event listeners to all images
    images.forEach((image, index) => {
      image.addEventListener('click', (e) => {
        e.preventDefault()
        showModal(index);
      });
    });

    // Add click event listeners to modal navigation arrows
    const prevArrow = modal.querySelector('.mw-modal-prev');
    prevArrow.addEventListener('click', showPrevImage);

    const nextArrow = modal.querySelector('.mw-modal-next');
    nextArrow.addEventListener('click', showNextImage);

    // Add click event listener to modal background to hide it
    modal.addEventListener('click', hideModal);


  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-top"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
      jQuery(document).ready(function($){
        $(function () {
          $('.js-btn-askquestion-model').magnificPopup({
            focus: '#contact_name',
            type: 'inline',
            fixedContentPos: false,
            fixedBgPos: true,
            overflowY: 'auto',
            closeBtnInside: true,
            preloader: false,
            midClick: true,
            removalDelay: 300,
            mainClass: 'my-mfp-zoom-in'
          });
        });

        /*
        var cols = $('.row .scroll-balance-section');
        var scrollbalance = new ScrollBalance(cols, {
            minwidth: 768
        });

        scrollbalance.bind();
        */
      });
  });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-purchased-popup"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
      jQuery(document).ready(function($){
          $('.akeans-popup-close').bind('click',function(){
              $('.customers-recently-purchased').remove();
              $.cookie('recentPopupCookie', 'true', {expires:1, path:'/'});
          });
    
          if ($.cookie('recentPopupCookie') == 'true') {
              $('.customers-recently-purchased').remove();
          }
    
          var $items = $('.customers-recently-purchased li');
          var init_element = 0;
          var i = 0;  
          $items.removeClass('active');
          function changeActiveRandomElement() { 
              if ( i % 2 == 0) {
                  var currentItem = $items.eq(init_element);      
                  currentItem.addClass('active');
                  setTimeout(function(){ 
                    currentItem.removeClass('active')
                  }, 4000);
        
                  init_element++;
                  if($items.length == init_element) {
                    init_element = 0;
                  }
              }
              i++;
          }
          setInterval(function(){ 
            changeActiveRandomElement();
          }, 3500);
      });
  });

  } catch(e) { console.error(e); }
})();
})();
